import React from 'react'
import styled from 'styled-components'
import ExpandSidebarIcon from './ExpandSidebarIcon'
import CollapseSidebarIcon from './CollapseSidebarIcon'

const Pane = styled.div`
  min-width: 300px;
  max-width: 300px;
  overflow-y: scroll;
`

const ContentContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 3px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`

const SidebarContainer = styled.div`
  height: 100%;
  position: absolute;
  ${({ left }) => (left ? 'left' : 'right')}: 0;
  top: 0;
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  ${({ docked, pixelShift }) => (docked ? '' : 'transform: translate3d(' + pixelShift + ', 0, 0);')}
  transition: transform .5s;
  background-color: ${({ theme }) => theme.colors.white1};
  z-index: 1;
  min-width: ${({ docked }) => (docked ? '300' : '330')}px;
  ${({ docked, boxShadow }) =>
    docked ? 'box-shadow: ' + boxShadow + ' 2px 2px rgba(0, 0, 0, 0.2);' : ''}
`

class Sidebar extends React.Component {
  render() {
    const { left, docked, toggleDocked } = this.props
    const pixelShift = left ? '-300px' : '300px'
    const boxShadow = left ? '2px' : '-2px'
    return (
      <SidebarContainer left={left} docked={docked} pixelShift={pixelShift} boxShadow={boxShadow}>
        <Pane>
          <CollapseSidebarIcon left={!left} toggleDocked={toggleDocked} docked={docked} />
          <ContentContainer>{this.props.children}</ContentContainer>
        </Pane>
        <ExpandSidebarIcon docked={docked} left={!left} toggleDocked={toggleDocked} />
      </SidebarContainer>
    )
  }
}

export default Sidebar
